
import axios, { AxiosError, CancelTokenSource } from 'axios';
import { ApiUrls } from '../constants/apiUrls'
import { ApiResponseHelper } from '../infrastructure/utils/ApiResponseHelper'
import { IApiResponse } from '../models/ApiResponseModels'
import {
    ClientProcessingService, MobileService, CreateTaskTagMobileServiceRequest,
    ResultCreateTaskTagMobileService, ServiceGroupEnum
} from "../models/ServiceModels"

export class ServicesRequests {

    private cancelTokenSource?: CancelTokenSource

    public Init(): void {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    public Abort(): void {
        this.cancelTokenSource?.cancel();

    }
    //Проверка доступности тарифа про
    public async GetAvailableMobileServices(personalAccountId: string): Promise<{ personalAccountId: string, response: IApiResponse<MobileService[]> }> {
        return await axios.get<IApiResponse<MobileService[]>>(`${ApiUrls.GetAvailableMobileServices}?personalAccountId=${personalAccountId}`,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => ({
                personalAccountId: personalAccountId,
                response: response.data
            }))
            .catch((error: AxiosError) => ({
                personalAccountId: personalAccountId,
                response: ApiResponseHelper.GetDefaultArrayResponse<MobileService>()
            }))
    }
    //Загрузка текущего статуса подключения тарифа про
    public async GetProcessingServices(personalAccountId: string, group?: ServiceGroupEnum, serviceId?: string): Promise<{ personalAccountId: string, response: IApiResponse<ClientProcessingService[]> }> {
        return await axios.post<IApiResponse<ClientProcessingService[]>>(`${ApiUrls.GetProcessingServices}`,
            {
                personalAccountId: personalAccountId,
                group: group,
                serviceId: serviceId
            },
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => ({
                personalAccountId: personalAccountId,
                response: response.data
            }))
            .catch((error: AxiosError) => ({
                personalAccountId: personalAccountId,
                response: ApiResponseHelper.GetDefaultArrayResponse<ClientProcessingService>()
            }))
    }
    //Создание запроса на подключение тариф про
    public async ActivationMobileService(request: CreateTaskTagMobileServiceRequest): Promise<IApiResponse<ResultCreateTaskTagMobileService | null>> {
        return await axios.post<IApiResponse<ResultCreateTaskTagMobileService | null>>(`${ApiUrls.ActivationMobileService}`,
            request,
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }
    //Отмена запроса на подключение
    public async CancelStatusProcessingService(clientProcessingServicesId: string): Promise<IApiResponse<{} | null>> {
        return await axios.post<IApiResponse<{} | null>>(`${ApiUrls.CancelProcessingServices}`,
            {
                clientProcessingServicesId: clientProcessingServicesId
            },
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

    public async CancelSubscriptionRenewal(personalAccountId: string, cancelComment: string|null): Promise<IApiResponse<{} | null>> {
        return await axios.post<IApiResponse<{} | null>>(`${ApiUrls.CancelSubscriptionRenewal}`,
            {
                personalAccountId: personalAccountId,
                cancelComment: cancelComment,
            },
            { cancelToken: this.cancelTokenSource?.token })
            .then(response => {
                return response.data;
            })
            .catch((error: AxiosError) => {
                if (axios.isCancel(error)) {
                    return { result: true, data: null, error: null, messageId: null }
                }
                return { result: false, data: null, error: ApiResponseHelper.GeneratorAxiosError(error), messageId: null }
            })
    }

}


